import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.98178 5.10982C6.40894 3.39722 8.68374 2 12 2C15.3163 2 17.5911 3.39722 19.0182 5.10982C20.0773 6.38067 20.6733 7.82942 20.8968 9H22V11H21V20H22V22H16.5V18.5C16.5 16.0147 14.4853 14 12 14C9.51472 14 7.5 16.0147 7.5 18.5V22H2V20H3V11H2V9H3.10317C3.32668 7.82942 3.92274 6.38067 4.98178 5.10982ZM18.8461 9C18.6403 8.231 18.2137 7.2685 17.4818 6.39018C16.7708 5.53703 15.7734 4.76496 14.4003 4.34117C14.5815 4.66019 14.7532 4.9995 14.9119 5.35201C15.4055 6.44866 15.799 7.73088 15.9419 9H18.8461ZM13.9261 9C13.7925 8.05122 13.4871 7.05935 13.0881 6.17299C12.8194 5.57591 12.5183 5.04984 12.2202 4.63657C12.144 4.53083 12.0703 4.43589 12 4.3512C11.9297 4.43589 11.856 4.53083 11.7798 4.63657C11.4817 5.04984 11.1806 5.57591 10.9119 6.17299C10.5129 7.05935 10.2075 8.05122 10.0739 9H13.9261ZM8.05806 9C8.20101 7.73088 8.59446 6.44866 9.08813 5.35201C9.24682 4.9995 9.41851 4.66019 9.59969 4.34117C8.22664 4.76496 7.22919 5.53703 6.51822 6.39018C5.78629 7.2685 5.35973 8.231 5.15392 9H8.05806Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 16C10.6193 16 9.5 17.1193 9.5 18.5V22H14.5V18.5C14.5 17.1193 13.3807 16 12 16Z"}}]};

const Shop2Filled = Vue.extend<IconProps>({
  name: 'Shop2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'shop-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Shop2Filled;
